import { render, staticRenderFns } from "./DictCheckbox.vue?vue&type=template&id=53e13302&"
import script from "./DictCheckbox.vue?vue&type=script&lang=js&"
export * from "./DictCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./DictCheckbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports